export * from './seo-faq-page-structured-data';
